import { createContext } from 'react';
import { ThemeStore } from './theme-store';

export const ThemeStoreContext = createContext<
    | {
          themeStore: ThemeStore;
      }
    | undefined
>(undefined);
